import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
/**
 * Distinctive side pane on the assistant's own posts — replaces the plain
 * avatar so bot replies read as "the assistant answered", not just another
 * member. Deliberately plain by default; themes are expected to skin it
 * (frame, glow, badge) via .Post--ai-bot / .AiBotPane-* hooks.
 */
export default class AiBotPane extends Component {
  view() {
    var _user$avatarUrl, _user$displayName;
    const user = this.attrs.user;
    const avatar = user == null || (_user$avatarUrl = user.avatarUrl) == null ? void 0 : _user$avatarUrl.call(user);
    const name = (user == null || (_user$displayName = user.displayName) == null ? void 0 : _user$displayName.call(user)) || '';
    return m("div", {
      className: "AiBotPane"
    }, m(Link, {
      href: app.route.user(user),
      className: "AiBotPane-frame",
      title: name
    }, avatar ? m("img", {
      src: avatar,
      alt: name,
      loading: "lazy"
    }) : m("span", {
      className: "AiBotPane-noimg",
      "aria-hidden": "true"
    }, m("i", {
      className: "fas fa-robot"
    }))), m("span", {
      className: "AiBotPane-badge"
    }, m("i", {
      className: "fas fa-wand-magic-sparkles",
      "aria-hidden": "true"
    }), " ", app.translator.trans('ernestdefoe-ai-helper.forum.bot_pane_label')));
  }
}
flarum.reg.add('ernestdefoe-ai-helper', 'forum/components/AiBotPane', AiBotPane);